import { render, staticRenderFns } from "./VideoPlyrJs.vue?vue&type=template&id=6d7b47ac&lang=pug&"
import script from "./VideoPlyrJs.vue?vue&type=script&lang=js&"
export * from "./VideoPlyrJs.vue?vue&type=script&lang=js&"
import style0 from "./VideoPlyrJs.vue?vue&type=style&index=0&id=6d7b47ac&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports